module.exports = __webpack_public_path__ + "static/media/07_avatar_male.441a30ba.png";